import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "group"]

  filter(event) {
    const category = event.currentTarget.dataset.category

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.category === category
      tab.classList.toggle("text-white", active)
      tab.classList.toggle("border-[var(--color-kova-accent)]", active)
      tab.classList.toggle("text-white/50", !active)
      tab.classList.toggle("border-transparent", !active)
    })

    this.groupTargets.forEach(group => {
      group.hidden = category !== "all" && group.dataset.category !== category
    })
  }
}
